import {Routes} from "@angular/router";
import {WorkflowChangeCuComponent} from "./workflow-change-cu.component";

export const workflowChangeCuRouting: Routes = [
    { path: 'change-cu/:aid', component: WorkflowChangeCuComponent},
]
